<!--
 * @Author: your name
 * @Date: 2020-11-20 09:41:55
 * @LastEditTime: 2020-11-25 09:33:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay/component/SignUpSuccessPage/index.vue
-->
<style scoped lang="sass">
.success_page
  display: flex
  flex-direction: column

.title
  line-height: 23PX
  text-align: center
  font-size: 23PX
  color: var(--menu-primary-text-colour)
  margin-top: 34Px
  margin-bottom: 20PX

.info
  margin-bottom: 88PX
  line-height: 13PX
  text-align: center
  font-size: 13PX
  color: var(--menu-primary-text-colour)
</style>

<template lang="pug">
.success_page
  .title.b {{ t('thank_you', 'Thank you!') }}
  .info.o7 {{ t('joined_mailing_list', 'You have successfully joined our mailing list.') }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { t } from '@/utils/language'

@Component
class SignUpSuccessPage extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }
}

export default SignUpSuccessPage
</script>
